import { useState } from 'react';
import { submitContactForm } from './services/apiService';

function ContactSection({ selectedPlanName, selectedValue }) {
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    setIsLoading(true);
    setStatus(null);

    try {
      await submitContactForm(formData);
      form.reset();
      setStatus('success');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setStatus('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-card">
        <div>
          <h2>Welcome to the team!</h2>
          <p className="contact-subtext">
            We&apos;ve mapped out your goals and your plan is ready. Complete your enrollment below to officially activate your account and access your dashboard.
          </p>
          <div className="selected-plan-display">
            <span>Selected plan:</span>
            <strong>{selectedPlanName}</strong>
          </div>
          <div className="qr-section">
            <img
              src="/qr_code.jpeg"
              alt="Instapay QR code for quick payment"
              className="qr-image"
            />
            <p className="qr-caption">Or scan to pay via Instapay.</p>
            <a
              href="https://ipn.eg/S/mohie90/instapay/1ClEuR"
              target="_blank"
              rel="noreferrer"
              className="qr-link"
            >
              mohie90@instapay
            </a>
          </div>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="hidden" name="period" value={selectedValue} />
          <label>
            Name
            <input type="text" name="name" placeholder="Your name" required />
          </label>
          <label>
            Email
            <input type="email" name="email" placeholder="you@example.com" required />
          </label>
          <label>
            Mobile Number
            <input
              type="tel"
              name="phone"
              placeholder="+20 10 1234 5678"
              required
            />
          </label>
          <button type="submit" className="primary" disabled={isLoading}>
            {isLoading ? 'Submitting...' : 'Submit'}
          </button>
          {status === 'success' && (
            <p className="form-status form-status--success">
              Thanks! Your details have been submitted.
            </p>
          )}
          {status === 'error' && (
            <p className="form-status form-status--error">
              Something went wrong while submitting the form. Please try again.
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default ContactSection;


